
import { Base } from '../base-component';

import './rich-text-modal.component.scss';

import * as $ from 'jquery';

export class RichTextModal extends Base {

	modals: Element[];
	modalLinks: Element[];
	activeModal: Element;
	closeButton: Element[];

	constructor(element: Element) {
		super(element);
		this.event.register('openModal', this, this.openModal.bind(this));
	}

	init() {
		this.modals = Array.from(this.element.querySelectorAll('.js-rich-text-modal-modal'));
		this.modalLinks = Array.from(document.querySelectorAll('.js-rich-text-modal-modal-open'));
		this.closeButton = Array.from(this.element.querySelectorAll('.js-rich-text-modal-modal-close'));
	}

	bindEvents() {

		this.modals.map((item) => item.addEventListener('click', (event) => {
			this.isClickOutsideModal(event);
		}));

		this.modalLinks.map((item) => item.addEventListener('click', (event) => {
			this.openModals(event);
        }));

		this.closeButton.map((item) => item.addEventListener('click', (event) => {
			this.closeModal()
        }));

		// this.closeButton.addEventListener('click', (event) => this.closeModal());

	}

	isClickOutsideModal(event) {

		if (event.target === this.activeModal) {
			this.closeModal();
		}

	}

	closeModal() {

		if(this.activeModal){
			this.activeModal.classList.add('modal--close');
		}else{
			this.activeModal = this.element.querySelector('.js-rich-text-modal-modal--opened');
			this.activeModal.classList.add('modal--close');
		}

		setTimeout(() => {
			this.activeModal.classList.add('modal--closed');
		}, 250);

	}

	openModals(event) {
		
		let element: Element = event.target;
		let modalId = element.getAttribute('data-modal');
		
		if(!modalId){
			let  parentElement = $(element).closest('.js-rich-text-modal-modal-open');
			modalId = parentElement.attr('data-modal');
		}

		this.activeModal = this.getModalById(modalId);
		this.openModal();

	}

	openModal() {
		this.activeModal.classList.remove('modal--close');
		this.activeModal.classList.remove('modal--closed');
	}

	getModalById(id) {
		return document.querySelector(`#${id}`);
	}

}



// WEBPACK FOOTER //
// ./components/rich-text-modal/rich-text-modal.component.ts